module.exports = __webpack_public_path__ + "static/media/0025_IMG_LES_MURS_LAGOON_W_VLA2100_VERTICALE.18fcfbca.png";